import ResponsiveGrid from "../ResponsiveGrid";
import KeyBox from "./box";

import data from '../../Data/takeawaysTwo.json'


const columns = {
    small: ["100%"],
    medium: ["auto", "auto"],
    large: ["auto", "auto"],
};

const rows = {
    small: ["auto"],
    medium: ["auto"],
    large: ["auto"],
};

function BoxRow({state}) {
    const stateData = data.find( datum => datum.state === state.toLowerCase())
    const takeaways = stateData.takeaways
    const recommendations = stateData.recommendations
    return (
        <ResponsiveGrid
            width="85%"
            gap="medium"
            pad="small"
            overrideColumns={columns}
            overrideRows={rows}
            id="trRow"
        >
            <KeyBox title="Takeaways" points={takeaways}/>
            <KeyBox title="Recommendations" points={recommendations} />
        </ResponsiveGrid>
    );
}

export default BoxRow